import { Auth } from 'aws-amplify';
import { errorsCode } from '../Login.enums';
import { useAuth } from 'hooks/useAuth';
import { useState } from 'react';
import { loggerInfo } from 'utils/infoLog';
import Analytics from 'helpers/analytics';
import { useToast } from '@welbe/web-design-system';

export const useNewPassword = () => {
	const { signIn } = useAuth();
	const { toast } = useToast();
	const [code, setCode] = useState<string>('');
	const [isLoading, setLoading] = useState<boolean>(false);
	const [errorMessage, setErrorMessage] = useState<string>('');
	const [hasError, setError] = useState<boolean>(false);
	const [hasErrorRegex, setErrorRegex] = useState<boolean>(false);
	const [password, setPassword] = useState<string>('');
	const [confirmPassword, setConfirmPassword] = useState<string>('');

	const checkPasswordValidity = (): boolean => {
		const regEx =
			// eslint-disable-next-line no-useless-escape
			/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_]).{8,}$/;
		if (!regEx.test(password)) {
			setErrorRegex(true);
			return false;
		}

		setErrorRegex(false);
		return true;
	};

	const checkFields = () => {
		if (
			code &&
			password &&
			confirmPassword === password &&
			checkPasswordValidity()
		) {
			return true;
		}

		return false;
	};

	const handleResendCode = async () => {
		const token = window.location.search.split('token=')[1];
		const email = window.atob(token);
		const username = email.trim();
		await Auth.forgotPassword(username);
	};

	const handleToast = (message?: string) => {
		toast.error(message || 'Rellena los campos marcados.');
	};

	const handleErrorMsg = () => {
		if (!password) {
			setErrorMessage('Introduzca una contraseña');
			return;
		}

		if (password !== confirmPassword) {
			setErrorMessage('Las contraseñas no coinciden');
			return;
		}

		setErrorMessage('');
	};

	const handleSubmit = async () => {
		setError(false);
		setErrorMessage('');
		if (checkFields()) {
			const token = window.location.search.split('token=')[1];
			if (!token) {
				handleToast(
					errorsCode[code]
						? errorsCode[code]
						: 'Hubo un error al intentar realizar esta acción.',
				);
				return;
			}
			const email = window.atob(token);

			try {
				setLoading(true);
				const username = email.trim();
				const pass = password.trim();
				await Auth.forgotPasswordSubmit(username, code, pass);
				await signIn({ username, password });
				Analytics.track('login', 'New Password', {
					email,
				});
			} catch (error: any) {
				Analytics.track('login', 'Error New Password', {
					email,
				});
				const code = JSON.parse(JSON.stringify(error))?.code;
				handleToast(
					errorsCode[code]
						? errorsCode[code]
						: 'Hubo un error al intentar realizar esta acción.',
				);
				loggerInfo({
					data: error,
					context: 'login',
					location: 'newPassword',
				});
				setLoading(false);
			}
		} else {
			setError(true);
			handleErrorMsg();
		}
	};

	return {
		code,
		hasErrorRegex,
		hasError,
		isLoading,
		password,
		confirmPassword,
		errorMessage,
		handleResendCode,
		setCode,
		setPassword,
		setConfirmPassword,
		handleSubmit,
	};
};
